// extracted by mini-css-extract-plugin
export var highlightOriginal = "_64-0";
export var highlightSuggested = "_64-1";